import { render, staticRenderFns } from "./ethnicityScanner.vue?vue&type=template&id=07dcca28&scoped=true&"
import script from "./ethnicityScanner.vue?vue&type=script&lang=ts&"
export * from "./ethnicityScanner.vue?vue&type=script&lang=ts&"
import style0 from "./ethnicityScanner.vue?vue&type=style&index=0&id=07dcca28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dcca28",
  null
  
)

export default component.exports